import { Component, OnInit } from '@angular/core';
import { sampleReciveModal } from '../Model/otherModule.model';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { AuthService } from 'app/auth/auth.service';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { OtherMoudleService } from '../othermodule.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-sample-receving',
  templateUrl: './sample-receving.component.html',
  styleUrls: ['./sample-receving.component.scss']
})
export class SampleRecevingComponent implements OnInit {
  destroysampleReceving$: Subject<boolean> = new Subject<boolean>();
  statusOptions: string[] = ['Pending', 'Accepted', 'Received', 'Rejected',];
  selectedStatus: string = 'Pending';
  selectedVisitType: string = 'OP';
  selectPatientRow: any
  datechange: any;
  sinListData: any = [];
  LabListData: any = [];
  sampleReciveModal: sampleReciveModal = {}
  private filteredLabBranchArray: Observable<any[]>;
  private filteredclinicalArray: Observable<any[]>;
  private labSampleCollectionDetailArray: any = [];
  private filteredSinnoArray: Observable<any[]>;
  private filteredLabnoArray: Observable<any[]>;

  AcceptedSamples: any = []
  headName: any;
  selectedPatientId: any;
  selectedIndex: number;
  sinControl: FormControl;
  branchControl: FormControl;
  LabControl: FormControl;

  private sampleRecivingArray: any = []
  sampleRecivingArrayOriginal: any = [];
  constructor(private authService: AuthService,
    private otherService: OtherMoudleService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.LabControl = new FormControl();
    this.sinControl = new FormControl();
    // this.sampleReciveModal.Date = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.initializeLabBranchControl();
    this.sampleReciveModal.branchName = this.authService.Loggeduser.branchname;
    this.sampleReciveModal.BranchId = this.authService.Loggeduser.branchid;
    this.sampleReciveModal.AcceptStatus = "Pending";
    this.getAllSampleRecivingData();
    this.getSinNoList('LABSINNOPENDINGOP', this.sampleReciveModal.BranchId)
    this.getLabnoList('LABNOPENDINGOP', this.sampleReciveModal.BranchId)
  }

  getStatusClass(status: string): string {
  switch (status) {
    case 'Pending':
      return 'status-pending';
    case 'Accepted':
      return 'status-accepted';
    case 'Rejected':
      return 'status-rejected';
    case 'Received':
      return 'status-received'; 
    default:
      return '';
  }
}

getStatusTitle(status: string): string {
  switch (status) {
    case 'Pending': return 'Pending';
    case 'Accepted': return 'Accepted';
    case 'Rejected': return 'Rejected';
    case 'Received': return 'Received';
    default: return '';
  }
}


 
  onDateChange() {
    this.datechange = moment(this.sampleReciveModal.Date).format('YYYY-MM-DD'),
      this.getAllSampleRecivingData();
  }

  onVisitTypeChange(value) {
    if (value === 'OP') {
      this.selectedVisitType = 'OP'
      this.getSinNoList('LABSINNOPENDINGOP', this.sampleReciveModal.BranchId)
      this.getLabnoList('LABNOPENDINGOP', this.sampleReciveModal.BranchId)
    this.getAllSampleRecivingData();
      
    } else if (value === 'IP') {
      this.selectedVisitType = 'IP'
      this.getSinNoList('LABSINNOPENDINGIP', this.sampleReciveModal.BranchId)
      this.getLabnoList('LABNOPENDINGIP', this.sampleReciveModal.BranchId)
      this.getAllSampleRecivingData();
    }
    this.sampleReciveModal.AcceptStatus = "Pending";
  }

  onBranchLabSelected(event) {
    this.sampleReciveModal.branchName = event.value;
    this.sampleReciveModal.BranchId = event.id;
       this.sampleReciveModal.Date = null;
      this.datechange = null;
    this.getAllSampleRecivingData();
  }
  clearLabBranchName(lbid) {
    if (!lbid) {
      this.sampleReciveModal.BranchId = null;
    }
  }

  initializeLabBranchControl() {
    this.branchControl = new FormControl();
    this.filteredLabBranchArray = this.branchControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterLabBranchFunction(branch)
          : this.authService.Branches.slice()
      )
    );
  }

  filterLabBranchFunction(name: string): any[] {
    return this.authService.Branches.filter((branch) =>
      branch.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }

  onSinnoSelected(event) {
    this.sampleReciveModal.SinNo = event.value;
    this.sampleReciveModal.sinID = event.id;
    this.getAllSampleRecivingData();
  }



  onStatusChange(selectedValue: any) {
    this.sampleReciveModal.AcceptStatus = selectedValue;
    this.getAllSampleRecivingData();
  }
  
  getSinNoList(visitType: any, branchid: any) {
    this.otherService.getSinNo(visitType, branchid).pipe(takeUntil(this.destroysampleReceving$)).subscribe((res: any) => {
      this.sinListData = res;
      this.initializeSinnoControl();
    })
  }

  
  getLabnoList(visitType: any, branchid: any) {
    this.otherService.getSinNo(visitType, branchid).pipe(takeUntil(this.destroysampleReceving$)).subscribe((res: any) => {
      this.LabListData = res;
      this.initializeLabnoControl()
    })
  }


  initializeSinnoControl() {
    this.sinControl = new FormControl();
    this.filteredSinnoArray = this.sinControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterSinFunction(branch)
          : this.sinListData.slice()
      )
    );
  }

  filterSinFunction(na: string): any[] {
    return this.sinListData.filter((list) =>
      list.name.toLowerCase().includes(na.toLowerCase())
    );
  }

  clearSinNo(sinNo) {
    if (!sinNo) {
      this.sampleReciveModal.SinNo = null;
      this.getAllSampleRecivingData();
    }
  }

  clearlabNo(lanNo) {
    if (!lanNo) {
      this.sampleReciveModal.LabNo = null;
      this.getAllSampleRecivingData();
    }
  }

  initializeLabnoControl() {
    this.LabControl = new FormControl();
    this.filteredLabnoArray = this.LabControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterSinFunction(branch)
          : this.LabListData.slice()
      )
    );
  }

  filterLabnoFunction(nlab: string): any[] {
    return this.LabListData.filter((list) =>
      list.name.toLowerCase().includes(nlab.toLowerCase())
    );
  }

  onLabSelected(event) {
    this.sampleReciveModal.LabNo = event.value;
    this.sampleReciveModal.labID = event.id;
    this.getAllSampleRecivingData();
  }

  getAllSampleRecivingData() {
    let payload = {
      "BranchID": this.sampleReciveModal.BranchId,
      "FromDate": this.datechange,
      "pType": this.selectedVisitType,
      "sinNo": this.sampleReciveModal.SinNo,
      "labNo": this.sampleReciveModal.LabNo,
      "AcceptStatus": this.sampleReciveModal.AcceptStatus,
      "SearchPara": "",
      "SearchParaValue": ""
    }
    this.otherService.getSampleReceving(payload).pipe(takeUntil(this.destroysampleReceving$)).subscribe((res: any) => {
      this.sampleRecivingArrayOriginal = res; // Keep original data
      this.sampleRecivingArray = [...res];
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  filterByPatientName() {
    const filterValue = this.sampleReciveModal.patientName.toLowerCase();
    this.sampleRecivingArray = this.sampleRecivingArrayOriginal.filter(item =>
      item.patientName?.toLowerCase().includes(filterValue)
    );
  }

  filterBylabname() {
    const filterValue = this.sampleReciveModal.labname.toLowerCase();
    this.sampleRecivingArray = this.sampleRecivingArrayOriginal.filter(item =>
      item.departmentName?.toLowerCase().includes(filterValue)
    );
  }
 
  rowsectiondata(item, index) {
    this.AcceptedSamples = [];
    this.selectPatientRow = item;
    this.selectedPatientId = item.patientID;
    this.selectedIndex = index;
    var chnageheadName = null;
    if( this.headName == "UPDATESAMPLERECEVINGSTATUSCOLLECTEDWITHACCEPTANCE"){
    chnageheadName = item.pK_TranID > 0 ? 'UPDATESAMPLERECEVINGSTATUSACCEPTED' : 'UPDATESAMPLERECEVINGSTATUSCOLLECTEDWITHACCEPTANCE'
    }else{
      chnageheadName = 'UPDATESAMPLERECEVINGSTATUSREJECTED';
    }

    this.AcceptedSamples.push({
      "HeadName":chnageheadName,
      "PType": item.pType,
      "SINID": item.sinid ? item.sinid : null,
      "PK_TranID": item.pK_TranID > 0 ? item.pK_TranID : 0,
      "PK_BillID": item.pK_BIllID,
      "BillDate": this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd"),
      "IsEdit": item.pK_TranID > 0 ? true : false,
      "FK_BillDetailID": item.pK_BillDetailId,
      "SampleQty": item.sampleQty,
      "SampleRemarks": item.sampleRemarks,
      "VialQty": item.vialQty,
      //"LabDeptCode": item.labDeptCode,
      "AcceptStatus": item.acceptStatus,
      "AcceptRemarks": this.sampleReciveModal.acceptedremark,
      // "TestApprovalStatus": item.testApprovalStatus
    });
  }
  checktype: any
  chnageStatusValue:any;
  openpopup(type) {
    this.checktype = type;
    if ( this.AcceptedSamples && this.AcceptedSamples.length > 0) {
      if (type == 1) {
        document.getElementById("acceptModal").style.display = "Block";
        this.headName = "UPDATESAMPLERECEVINGSTATUSCOLLECTEDWITHACCEPTANCE";
        // this.chnageStatusValue = '';
      } else if (type == 2) {
        document.getElementById("acceptModal").style.display = "Block";
        this.headName = "UPDATESAMPLERECEVINGSTATUSREJECTED";
        // this.chnageStatusValue = '';

      }
    }else{
        this.dashboardService.openSnackBar("Please Select Row", "OK");
    }
  }

  yes() {
    if (this.checktype == 1) {
      this.statusChnage();
      document.getElementById("acceptModal").style.display = "None";
    } else {
      document.getElementById("rejectModal").style.display = "Block";
      document.getElementById("acceptModal").style.display = "None";
    }
  }

  yesrejected() {
    if(!this.sampleReciveModal.acceptedremark){
        this.dashboardService.openSnackBar("Please Enter the Reason", "OK");
        return;
    }
    this.statusChnage();
    document.getElementById("rejectModal").style.display = "None";
  }

  Cancelreject() {
    document.getElementById("rejectModal").style.display = "None";
  }

  Cancelpopup(){
      document.getElementById("acceptModal").style.display = "None";
  }
  statusChnage() {
    if (this.selectPatientRow && this.selectedIndex >= 0) {
      this.rowsectiondata(this.selectPatientRow, this.selectedIndex);
    }

    let payload = {
      InsertLabSampleCollectionDetail: this.AcceptedSamples
    }

    this.otherService.InsertUpdateSampleStatus(payload).pipe(takeUntil(this.destroysampleReceving$)).subscribe((res) => {
      if (res && res.statusCode == '1') {
        this.getAllSampleRecivingData();
       this.checktype == 1 ?  this.dashboardService.openSnackBar("Record Accepted Successfully", "OK") :this.dashboardService.openSnackBar("Record Rejected Successfully", "OK")
        this.sampleReciveModal.acceptedremark = null;
        this.selectedIndex = -1;
        this.AcceptedSamples = null;
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error && err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }

  ngOnDestroy() {
    this.destroysampleReceving$.next(true);
    this.destroysampleReceving$.unsubscribe();
    this.AcceptedSamples = null;
    this.filteredSinnoArray = null;
    this.LabListData = null;
    this.sinListData = null;
    this.sampleRecivingArrayOriginal = null;
    this.sampleRecivingArray = null;
    this.filteredLabnoArray = null;
    this.filteredSinnoArray = null;
  }

}
